
import React from "react";
import ValidatedInput from "./ValidatedInput";
import { VehicleTypeSelect, YearSelect, RegionSelect } from "./selects";

// Vehicle Information Section
interface VehicleInfoSectionProps {
  vehicleMake: string;
  setVehicleMake: (value: string) => void;
  vehicleType: string;
  setVehicleType: (value: string) => void;
  vehicleColor: string;
  setVehicleColor: (value: string) => void;
  vehicleYear: string;
  setVehicleYear: (value: string) => void;
  vehicleCapacity: string;
  setVehicleCapacity: (value: string) => void;
  licensePlate: string;
  setLicensePlate: (value: string) => void;
  licensePlateRegion: string;
  setLicensePlateRegion: (value: string) => void;
}

export const VehicleInfoSection = ({
  vehicleMake, setVehicleMake,
  vehicleType, setVehicleType,
  vehicleColor, setVehicleColor,
  vehicleYear, setVehicleYear,
  vehicleCapacity, setVehicleCapacity,
  licensePlate, setLicensePlate,
  licensePlateRegion, setLicensePlateRegion
}: VehicleInfoSectionProps) => {
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <label htmlFor="vehicleMake" className="block text-sm font-medium text-black">
          Vehicle Make
        </label>
        <ValidatedInput
          id="vehicleMake"
          value={vehicleMake}
          onChange={(e) => setVehicleMake(e.target.value)}
          placeholder="Enter make (e.g. Toyota, BMW)"
        />
      </div>
      
      <VehicleTypeSelect 
        value={vehicleType} 
        onChange={setVehicleType} 
      />
      
      <div className="space-y-2">
        <label htmlFor="vehicleColor" className="block text-sm font-medium text-black">
          Vehicle Color
        </label>
        <ValidatedInput
          id="vehicleColor"
          value={vehicleColor}
          onChange={(e) => setVehicleColor(e.target.value)}
          placeholder="Enter color (e.g. Black, Silver)"
        />
      </div>
      
      <YearSelect 
        value={vehicleYear} 
        onChange={setVehicleYear} 
      />
      
      <div className="space-y-2">
        <label htmlFor="vehicleCapacity" className="block text-sm font-medium text-black">
          Vehicle Capacity
        </label>
        <ValidatedInput
          id="vehicleCapacity"
          value={vehicleCapacity}
          onChange={(e) => setVehicleCapacity(e.target.value)}
          type="number"
          min="1"
          max="100"
          placeholder="Enter passenger capacity"
        />
      </div>
      
      <div className="space-y-2">
        <label htmlFor="licensePlate" className="block text-sm font-medium text-black">
          License Plate #
        </label>
        <ValidatedInput
          id="licensePlate"
          value={licensePlate}
          onChange={(e) => setLicensePlate(e.target.value)}
          placeholder="Enter Number"
        />
      </div>
      
      <RegionSelect 
        value={licensePlateRegion} 
        onChange={setLicensePlateRegion} 
      />
    </div>
  );
};

export default VehicleInfoSection;
